import React from 'react';
import { createRoot } from 'react-dom/client';
import Application from './src/Application';

createRoot(document.getElementById('application'))
  .render(<Application/>);
